"use client";

import { useContext } from "react";
import { GlobalContext } from "@/contexts/SiteDataContext";
import usePrepareProps from "./hooks/usePrepareProps";
import { ButtonProps } from "./types";
import Image from "next/image";

const Button = ({
  tag,
  buttonSubmit,
  className,
  link,
  rootLink,
  prefetch,
  setTarget,
  buttonId,
  download,
  disabled,
  icon,
  label,
  template,
  svg,
  ...props
}: ButtonProps) => {
  const { classnames, Tag, buttonLink, buttonType } = usePrepareProps({
    ...props,
    tag,
    className,
    disabled,
    icon,
    link,
    rootLink,
    buttonSubmit,
    template,
    label,
  });

  const { setContext } = useContext(GlobalContext);

  const handleClick = (ev: any) => {
    if (typeof props.onClick === "function") props.onClick(ev);
    if (setContext && props.source) {
      setContext((prev: any) => ({ ...prev, sourceURL: props.source }));
    }
  };

  return (
    <Tag
      href={buttonLink}
      prefetch={link ? prefetch : undefined}
      state={props.source ? { source: props.source } : undefined}
      type={buttonType}
      target={setTarget}
      id={buttonId}
      download={download ? true : false}
      className={classnames}
      disabled={disabled}
      data-anl={props.dataAnl}
      data-qa={props.dataQa}
      data-testid={props.testId}
      onClick={handleClick}>
      <span className="button__text">{label}</span>
      {icon && (
        <Image
          src={icon}
          className={`button__icon`}
          alt={`${label}-img-icon`}
          width={50}
          height={50}
        />
      )}
      {svg && (
        <div
          className={`button__icon`}
          role="img"
          aria-label={`${label}-svg-icon`}
          title={`${label}-svg-icon`}>
          {svg}
        </div>
      )}
    </Tag>
  );
};

export default Button;
